import { Component, Input } from '@angular/core';
import { LovablePost } from './lovable-dashboard.models';

@Component({
    selector: 'app-lovable-post-card',
    templateUrl: './lovable-post-card.component.html',
    styleUrls: ['./lovable-post-card.component.css'],
})
export class LovablePostCardComponent {
    @Input() post!: LovablePost;

    showMenu = false;

    toggleMenu(event: Event): void {
        event.stopPropagation();
        this.showMenu = !this.showMenu;
    }

    closeMenu(): void {
        this.showMenu = false;
    }
}
